import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { id: "mitarbeiterform" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "row mb-5 mt-5 align-items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Legende")
], -1)
const _hoisted_5 = { class: "col-12" }
const _hoisted_6 = { class: "row align-items-center text-center" }
const _hoisted_7 = { class: "col circlerow nofeedbackrow" }
const _hoisted_8 = { class: "description" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = { class: "circlerow col" }
const _hoisted_11 = { class: "description" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = { class: "circlerow col" }
const _hoisted_14 = { class: "description" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = { class: "circlerow col" }
const _hoisted_17 = { class: "description" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = { class: "circlerow col" }
const _hoisted_20 = { class: "description" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_22 = { class: "circlerow col" }
const _hoisted_23 = { class: "description" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_25 = { class: "circlerow col" }
const _hoisted_26 = { class: "description" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_28 = { class: "circlerow col" }
const _hoisted_29 = { class: "description" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "row mt-5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-12 margin-t-s" }, [
    /*#__PURE__*/_createElementVNode("h1", null, "Skills Einschätzung"),
    /*#__PURE__*/_createElementVNode("h2", null, "Skills ändern, Skills anpassen")
  ])
], -1)
const _hoisted_32 = { class: "row text-center header-row fixed" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, null, -1)
const _hoisted_34 = { class: "col-8" }
const _hoisted_35 = { class: "row" }
const _hoisted_36 = {
  key: 0,
  class: "offset-1 col-lg-2 header-line"
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-2 header-line" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Selbst")
], -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-2 header-line" }, [
  /*#__PURE__*/_createElementVNode("span", null, "360°")
], -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "offset-1 col-lg-2 header-line" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Abgestimmt")
], -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-2 header-line" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Zielwert")
], -1)
const _hoisted_41 = { class: "row skill pt-2" }
const _hoisted_42 = { class: "col-4" }
const _hoisted_43 = { class: "row" }
const _hoisted_44 = { class: "col-lg-12" }
const _hoisted_45 = { class: "col-8" }
const _hoisted_46 = { class: "row" }
const _hoisted_47 = {
  key: 0,
  class: "col-lg-2 align-items-center offset-1"
}
const _hoisted_48 = { class: "col-lg-2 align-items-center" }
const _hoisted_49 = { class: "col-lg-2 align-items-center" }
const _hoisted_50 = { class: "col-lg-2 align-items-center offset-1" }
const _hoisted_51 = { class: "col-lg-2 align-items-center" }
const _hoisted_52 = { key: 1 }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", { class: "row text-center header-row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, "Lade Daten...")
], -1)
const _hoisted_54 = [
  _hoisted_53
]
const _hoisted_55 = {
  key: 0,
  class: "row mt-5"
}
const _hoisted_56 = { class: "col-12" }
const _hoisted_57 = ["placeholder"]
const _hoisted_58 = { class: "row mt-3" }
const _hoisted_59 = { class: "col-12" }
const _hoisted_60 = {
  key: 1,
  class: "row mt-5"
}
const _hoisted_61 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Dateien")
], -1)
const _hoisted_62 = { class: "col-12" }
const _hoisted_63 = { class: "files-outer" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("h2", null, "Dateien löschen", -1)
const _hoisted_65 = { class: "files-outer" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("h2", null, "Dateien hochladen", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_SkillCircle = _resolveComponent("SkillCircle")!
  const _component_UserDropdown = _resolveComponent("UserDropdown")!
  const _component_Skill = _resolveComponent("Skill")!
  const _component_FileList = _resolveComponent("FileList")!
  const _component_MultiUpload = _resolveComponent("MultiUpload")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (!_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createTextVNode("Nicht einschätzbar"),
                      _hoisted_9,
                      _createVNode(_component_Tooltip, { position: "left" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Kann nicht eingeschätzt werden ")
                        ]),
                        _: 1
                      })
                    ]),
                    _createVNode(_component_Icon, {
                      class: "symbol",
                      path: _ctx.mdiCancel,
                      width: 50,
                      height: 50
                    }, null, 8, ["path"])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createTextVNode(" None"),
                      _hoisted_12,
                      _createVNode(_component_Tooltip, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Die Kompetenz ist zur selbstständigen Erledigung der Aufgaben in den meisten Arbeitssituationen nicht ausreichend entwickelt. ")
                        ]),
                        _: 1
                      })
                    ]),
                    _createVNode(_component_SkillCircle, {
                      value: 0,
                      locked: ""
                    })
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createTextVNode(" Basic"),
                      _hoisted_15,
                      _createVNode(_component_Tooltip, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Die Kompetenz ist so weit entwickelt, dass sie in gleichbleibenden Arbeitssituationen unter Anleitung angewendet werden kann, aber die:der Mitarbeiter:in arbeitet die meiste Zeit unter Aufsicht.")
                        ]),
                        _: 1
                      })
                    ]),
                    _createVNode(_component_SkillCircle, {
                      value: 0.17,
                      locked: ""
                    }, null, 8, ["value"])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createTextVNode(" Intermediate"),
                      _hoisted_18,
                      _createVNode(_component_Tooltip, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Die Kompetenz kann in gleichbleibenden Situationen selbsständig angewendet werden. Das Arbeitsergebnis muss jedoch von anderen Personen kontrolliert werden.")
                        ]),
                        _: 1
                      })
                    ]),
                    _createVNode(_component_SkillCircle, {
                      value: 0.33,
                      locked: ""
                    }, null, 8, ["value"])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createTextVNode(" Trained"),
                      _hoisted_21,
                      _createVNode(_component_Tooltip, { position: "center" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Die Kompetenz ist so weit entwickelt, dass die:der Mitarbeiter:in in einem definierten Teilbereich, ohne Anleitung, selbstständig arbeitet und Ergebnisse nicht engmaschig kontrolliert werden müssen. Standardsituationen können abstrahiert und selbstständig bearbeitet werden.")
                        ]),
                        _: 1
                      })
                    ]),
                    _createVNode(_component_SkillCircle, {
                      value: 0.5,
                      locked: ""
                    }, null, 8, ["value"])
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createTextVNode(" Advanced"),
                      _hoisted_24,
                      _createVNode(_component_Tooltip, { position: "right" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Die Kompetenz ist so weit entwickelt, dass die:der Mitarbeiter:in ohne Anleitung selbsständig Standardsituationen und Sonderfälle adäquat erledigen kann.")
                        ]),
                        _: 1
                      })
                    ]),
                    _createVNode(_component_SkillCircle, {
                      value: 0.67,
                      locked: ""
                    }, null, 8, ["value"])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _createTextVNode(" Experienced"),
                      _hoisted_27,
                      _createVNode(_component_Tooltip, { position: "right" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Die Kompetenz ist so weit entwickelt, dass die:der Mitarbeiter:in ohne Anleitung selbstständig Standardsituationen und Sonderfälle adäquat erledigen kann und über ein gesamtheitliches Verständnis der eigenen und angrenzenden Tätigkeiten verfügt sowie Teams sachlich anleiten/führen kann bzw. könnte.")
                        ]),
                        _: 1
                      })
                    ]),
                    _createVNode(_component_SkillCircle, {
                      value: 0.83,
                      locked: ""
                    }, null, 8, ["value"])
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _createTextVNode(" Extraordinary"),
                      _hoisted_30,
                      _createVNode(_component_Tooltip, { position: "right" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Die Kompetenz ist so weit entwickelt, dass die Person durchgängig hervorragende Leistungen bei der Anwendung dieser Fähigkeiten über mehrere Projekte und Bereiche hinweg zeigen kann. Die Person hat die Fähigkeit, maßgeschneiderten Rat zu geben und diesen mit relevanten, kontextspezifischen Argumenten zeitnah zu untermauern; ist außerdem in der Lage, andere in der Anwendung dieser Fähigkeit zu coachen, unabhängig vom Bereich der Expertise.")
                        ]),
                        _: 1
                      })
                    ]),
                    _createVNode(_component_SkillCircle, {
                      value: 6 / 6,
                      locked: ""
                    })
                  ])
                ])
              ])
            ]),
            _hoisted_31,
            _createElementVNode("div", _hoisted_32, [
              _hoisted_33,
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  (_ctx.gradingusers.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                        _createVNode(_component_UserDropdown, {
                          users: _ctx.gradingusers,
                          onChanged: _ctx.filterDetails,
                          withbackevent: ""
                        }, null, 8, ["users", "onChanged"])
                      ]))
                    : _createCommentVNode("", true),
                  _hoisted_37,
                  _hoisted_38,
                  _hoisted_39,
                  _hoisted_40
                ])
              ])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.types, (typ) => {
              return (_openBlock(), _createElementBlock("div", {
                key: typ.name,
                class: "container-fluid mt-2"
              }, [
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("h3", null, _toDisplayString(typ.name), 1)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredskills(typ.type), (skill) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "row skill text-center align-items-center",
                    key: skill.id
                  }, [
                    _createElementVNode("div", _hoisted_42, [
                      _createElementVNode("div", _hoisted_43, [
                        _createElementVNode("div", _hoisted_44, [
                          _createVNode(_component_Skill, {
                            skill: skill,
                            isFuture: _ctx.isFuture(skill),
                            isStrategic: _ctx.isStrategic(skill)
                          }, null, 8, ["skill", "isFuture", "isStrategic"])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("div", _hoisted_46, [
                        (_ctx.gradingusers.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                              (_ctx.filter != -1 && _ctx.skillmatrix[skill.id]?.detailed && _ctx.skillmatrix[skill.id].detailed[_ctx.filter])
                                ? (_openBlock(), _createBlock(_component_SkillCircle, {
                                    key: 0,
                                    value: _ctx.skillmatrix[skill.id].detailed[_ctx.filter],
                                    locked: ""
                                  }, null, 8, ["value"]))
                                : _createCommentVNode("", true),
                              (_ctx.filter != -1 && (!_ctx.skillmatrix[skill.id]?.detailed || !_ctx.skillmatrix[skill.id]?.detailed[_ctx.filter]))
                                ? (_openBlock(), _createBlock(_component_Icon, {
                                    key: 1,
                                    class: "symbol",
                                    path: _ctx.mdiCancel,
                                    width: 50,
                                    height: 50
                                  }, null, 8, ["path"]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_48, [
                          (_ctx.skillmatrix[skill.id].self >= 0)
                            ? (_openBlock(), _createBlock(_component_SkillCircle, {
                                key: 0,
                                value: _ctx.skillmatrix[skill.id].self,
                                locked: ""
                              }, null, 8, ["value"]))
                            : _createCommentVNode("", true),
                          (_ctx.skillmatrix[skill.id].self < 0)
                            ? (_openBlock(), _createBlock(_component_Icon, {
                                key: 1,
                                class: "symbol",
                                path: _ctx.mdiCancel,
                                width: 50,
                                height: 50
                              }, null, 8, ["path"]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_49, [
                          _createVNode(_component_SkillCircle, {
                            value: _ctx.skillmatrix[skill.id].value,
                            locked: ""
                          }, null, 8, ["value"])
                        ]),
                        _createElementVNode("div", _hoisted_50, [
                          _createVNode(_component_SkillCircle, {
                            modelValue: _ctx.skillmatrix[skill.id].set,
                            "onUpdate:modelValue": [($event: any) => ((_ctx.skillmatrix[skill.id].set) = $event), ($event: any) => (_ctx.saveSet(skill.id))]
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_51, [
                          _createVNode(_component_SkillCircle, {
                            modelValue: _ctx.skillmatrix[skill.id].target,
                            "onUpdate:modelValue": [($event: any) => ((_ctx.skillmatrix[skill.id].target) = $event), ($event: any) => (_ctx.saveTarget(skill.id))]
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ])
                      ])
                    ])
                  ]))
                }), 128))
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_52, _hoisted_54))
        : _createCommentVNode("", true)
    ]),
    (_ctx.user)
      ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
          _createElementVNode("div", _hoisted_56, [
            _createElementVNode("h1", null, _toDisplayString(_ctx.$t('management.plan')), 1),
            _withDirectives(_createElementVNode("textarea", {
              placeholder: `${_ctx.$t('management.entertext')}...`,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.user.notiz) = $event))
            }, null, 8, _hoisted_57), [
              [_vModelText, _ctx.user.notiz]
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_58, [
      _createElementVNode("div", _hoisted_59, [
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.saveNotiz && _ctx.saveNotiz(...args)))
        }, _toDisplayString(_ctx.$t('management.save')), 1)
      ])
    ]),
    (_ctx.user)
      ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
          _hoisted_61,
          _createElementVNode("div", _hoisted_62, [
            _createElementVNode("div", _hoisted_63, [
              _hoisted_64,
              _createVNode(_component_FileList, {
                files: _ctx.user.files,
                onDel: _ctx.onDelete,
                edit: ""
              }, null, 8, ["files", "onDel"])
            ]),
            _createElementVNode("div", _hoisted_65, [
              _hoisted_66,
              _createVNode(_component_MultiUpload, { onFinished: _ctx.onAdded }, null, 8, ["onFinished"])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}